<template>
  <div class="raisePrice">
    <div class="top">
      <p>优惠券</p>
      <p>
        <span v-if="JSON.stringify(amount) !== '{}'">-￥{{amount.amount}}</span>
        <button @click="close">使用优惠券</button>
      </p>
    </div>
    <div class="desc">我要加价（加价有助于更快被接单）</div>
    <ul class="list">
      <li :class="i == index ? 'on' : '' " class="item" v-for="(item, index) in price" :key="index" @click="handleClick(index)">+{{item}}元</li>
    </ul>
    <use-coupon v-if="isShow" @close="close" />
  </div>
</template>

<script>
import UseCoupon from './UseCoupon'
import {mapState} from 'vuex'
export default {
  data () {
    return {
       price: ['5', '10', '20', '35', '60', '90', '150', '200'],
      i: -1,
      isShow: false
    }
  },
  methods: {
    handleClick (i) {
      if(i == this.i) {
        this.i = -1
        this.$store.dispatch('getAddFee', 0)
      } else {
        this.i = i
        this.$store.dispatch('getAddFee', this.price[i])
      }

    },
    close() {
      this.isShow = !this.isShow
    }
  },
  deactivated() {
    this.i = -1
  },
  computed: {
    ...mapState(['amount'])
  },
  components: {
    UseCoupon
  }
}
</script>

<style scoped lang="less" type="text/less">
.raisePrice{
  .top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    p{
      font-size: 16px;
      button{
        width: 120px;
        height: 36px;
        background: #FFC168;
        border:none;
        color: #ffffff;
        margin-left: 14px;
        font-size: 14px;
      }
    }
  }
  .desc{
    margin-top:19px;
  }
  .list{
    display: flex;
    flex-wrap: wrap;
    width: 420px;
    margin-top:30px;
    .item{
      width: 80px;
      height: 40px;
      line-height: 40px;
      margin-right: 20px;
      margin-bottom: 20px;
      border:1px solid #999;
      border-radius: 20px;
      text-align: center;
      cursor: pointer;
      &.on{
        background: #2FA1DE;
        color:#fff;
        border:1px solid #2FA1DE;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Courier/RaisePrice.vue